// data.js

export const testimonials = [
  {
    name: 'Phani Kumar Varma',
    review: 'I joined the Java Full Stack course with very little confidence, but every class was explained in a simple way. The live sessions, assignments, and doubt support helped me improve a lot. I can now build projects on my own. This course is definitely worth it.',
    rating: 5,
    place: 'Hyderabad',
  },
  {
    name: 'Achammagari Vijaya Lakshmi',
    review: 'As a beginner, I was worried whether I could understand programming. The instructors explained every topic patiently in Telugu with practical examples. The recorded sessions and project guidance made learning much easier for me.',
    rating: 5,
    place: 'Vijayawada',
  },
  {
    name: 'Naveen Kumar Prasad',
    review: 'I compared many online courses before joining GrapplTech. The curriculum is well structured and covers everything from basics to advanced concepts. The mentors were always available whenever I had doubts. Highly recommended.',
    rating: 5,
    place: 'Bangalore',
  },
  {
    name: 'Adluri Anil Kumar',
    review: 'The best part of this course is the practical approach. Every concept is followed by coding exercises and real-world projects. I never felt bored during the sessions because everything was explained with examples.',
    rating: 5,
    place: 'Tirupati',
  },
  {
    name: 'Nandyala Mahesh',
    review: 'I had taken another Java course before, but this one completely changed my understanding. The teaching style is simple, engaging, and easy to follow. Building projects gave me the confidence to attend interviews.',
    rating: 5,
    place: 'Kurnool',
  },
  {
    name: 'Prasanna Kumar Yerla',
    review: 'The support team responds quickly, and the mentors genuinely care about student progress. Every doubt I posted was answered with patience. I learned much more than I expected from this course.',
    rating: 5,
    place: 'Visakhapatnam',
  },
  {
    name: 'Venkatesh K',
    review: 'The roadmap provided in this course is excellent. Instead of randomly learning technologies, I now know exactly what to study and in what order. The projects are industry-oriented and very useful.',
    rating: 5,
    place: 'Chennai',
  },
  {
    name: 'Shaik Rubeena',
    review: 'I really liked the way difficult concepts were broken down into simple explanations. The Telugu teaching style made it very comfortable to learn. This is one of the best investments I have made in my career.',
    rating: 5,
    place: 'Kadapa',
  },
  {
    name: 'Gundlapalli Nikhil Reddy',
    review: 'The assignments and coding challenges helped me improve my problem-solving skills every week. I never imagined I could build full-stack applications within a few months. Thank you to the entire team.',
    rating: 5,
    place: 'Nellore',
  },
  {
    name: 'Bhutham Sailaja',
    review: 'Being from a non-technical background, I was nervous at first. But the instructors made every topic beginner-friendly. The encouragement from the mentors kept me motivated throughout the course.',
    rating: 5,
    place: 'Guntur',
  },
  {
    name: 'Shaik Riyaz',
    review: 'The projects included in this course helped me understand how software is actually built. Instead of only learning theory, we developed complete applications step by step. That made a huge difference.',
    rating: 5,
    place: 'Anantapur',
  },
  {
    name: 'Govind Cherukuru',
    review: 'I enrolled mainly for Java, but I ended up learning much more including databases, backend development, and deployment. The content is updated and relevant to current industry requirements.',
    rating: 5,
    place: 'Rajahmundry',
  },
  {
    name: 'Koyi Kishore',
    review: 'The instructors explain every line of code instead of simply copying and pasting. That helped me understand the logic behind programming. I now enjoy solving coding problems every day.',
    rating: 5,
    place: 'Warangal',
  },
  {
    name: 'Joseph P',
    review: 'I appreciate the consistency of the classes. Every session builds upon the previous one, making the learning journey smooth. The projects also look great in my portfolio.',
    rating: 5,
    place: 'Kochi',
  },
  {
    name: 'Tottukolla Pallavi',
    review: 'This course exceeded my expectations. The mentors encouraged us to ask questions, and no doubt was considered too small. I feel much more confident about my technical skills now.',
    rating: 5,
    place: 'Ongole',
  },
  {
    name: 'Seelam Sridhar',
    review: 'The interview preparation sessions were extremely helpful. Resume guidance, mock interviews, and coding practice gave me confidence to attend placements. I sincerely thank the mentors.',
    rating: 5,
    place: 'Kakinada',
  },
  {
    name: 'Ramya Chavala',
    review: 'I loved the combination of theory, live coding, and projects. Every module is explained clearly with practical examples. Even after completing the classes, I still revisit the recordings regularly.',
    rating: 5,
    place: 'Hyderabad',
  },
  {
    name: 'Muddapolu Venkatesh',
    review: 'The quality of the course is much better than many expensive bootcamps. Everything is organized properly, and the instructors genuinely want students to succeed. I would definitely recommend it.',
    rating: 5,
    place: 'Vijayawada',
  },
  {
    name: 'Chappalli Saranya',
    review: 'I joined with zero coding experience and now I can confidently build responsive websites and backend applications. The step-by-step teaching approach made learning enjoyable.',
    rating: 5,
    place: 'Tirupati',
  },
  {
    name: 'Shaik Rahim',
    review: 'The mentors not only teach programming but also explain how to prepare for interviews and work in real software companies. That practical guidance makes this course unique.',
    rating: 5,
    place: 'Kurnool',
  },
  {
    name: 'Gorantla Sridhar Reddy',
    review: 'Every project taught me something new. Instead of memorizing syntax, I learned how to think like a developer. This course completely changed my perspective towards programming.',
    rating: 5,
    place: 'Kadapa',
  },
  {
    name: 'Rajitha Akkari',
    review: 'The classes are interactive and never feel monotonous. The instructors encourage participation and make learning enjoyable. I looked forward to attending every live session.',
    rating: 5,
    place: 'Visakhapatnam',
  },
  {
    name: 'Shaik Yasmin',
    review: 'One of the biggest advantages is lifetime access to recordings. Whenever I forget a concept, I simply watch the session again. This flexibility helped me learn at my own pace.',
    rating: 5,
    place: 'Nizamabad',
  },
  {
    name: 'Vandana Reddy',
    review: 'I have completed several online courses before, but this is the first one where I actually finished every assignment. The motivation from the mentors kept me consistent throughout.',
    rating: 5,
    place: 'Hyderabad',
  },
  {
    name: 'Jonnala Bhavana',
    review: 'The Full Stack curriculum is comprehensive and beginner-friendly. From HTML to backend development, everything is covered in a structured manner. I am very satisfied with my learning experience.',
    rating: 5,
    place: 'Guntur',
  },
  {
    name: 'Sirisha C',
    review: 'The community support is amazing. Whenever someone asks a question, mentors respond quickly with clear explanations. It feels like learning with a supportive family rather than just another online course.',
    rating: 5,
    place: 'Chennai',
  },
  {
    name: 'Yuva Prashanth',
    review: 'The projects helped me understand industry practices instead of just writing basic programs. Git, deployment, APIs, and databases were explained in a practical way. Excellent course overall.',
    rating: 5,
    place: 'Bangalore',
  },
  {
    name: 'Prudhvi Maddela',
    review: 'The instructor has an excellent teaching style. Complex topics become simple with real-life examples and live coding demonstrations. I feel much more prepared for software development roles now.',
    rating: 5,
    place: 'Anantapur',
  },
  {
    name: 'Bhargav Reddy',
    review: 'I would confidently recommend this course to anyone who wants to start a career in software development. The content, mentorship, projects, and interview guidance are all excellent. It has been a wonderful learning journey.',
    rating: 5,
    place: 'Tirupati',
  },
];

export const instructors = [
  {
    name: 'Jane Smith',
    expertise: 'Java',
    location: 'Guduvanchery',
  },
];

export const bootcamps = [
  {
    title: 'Software Development Intern',
    location: 'Bangalore',
  },
];